module.exports = __webpack_public_path__ + "media/images/registration/fed_gov_contractor_user-495e806c30c17248a5940f2a2bd1e0f0.png";